import React, { useEffect, useState } from 'react'
import MainBackground from '../../assets/out-login/background.jpg'
import { Button, Checkbox, Form, Input, Space, Typography, Alert } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

import './out-login.styles.scss'
import { ILoginRequest } from '../../common/login.interface';
import { useNavigate } from "react-router-dom";
import { useDispatchRoot, useSelectorRoot } from '../../redux/store';
import { loginRequest } from '../../redux/controller';

const { Title, Text, Link } = Typography;

const OutLoginLayout = () => {

	const navigate = useNavigate();
	const dispatch = useDispatchRoot();
	const [form] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);

	const {
		tokenLogin,
		loginError
	} = useSelectorRoot((state) => state.login);

	useEffect(() => {
		if (tokenLogin) {
			navigate('/management/book')
		}
	}, [tokenLogin, navigate])

	const onFinish = async (values: any) => {
		setIsLoading(true);
		try {
			const bodyRequest: ILoginRequest = {
				email: values.email,
				password: values.password,
			};
			dispatch(loginRequest(bodyRequest));
		} catch (error) {
			console.error('Login error:', error);
		} finally {
			setIsLoading(false);
		}
	}

	return (
		<div className='main'>
			<div className='content-area'>
				<div className='login-container'>
					<div className='login-card'>
						<div className='login-header'>
							<Title level={2} className='login-title'>
								Đăng nhập hệ thống
							</Title>
							<Text type="secondary" className='login-subtitle'>
								Chào mừng bạn quay lại! Vui lòng đăng nhập để tiếp tục.
							</Text>
						</div>

						{loginError && (
							<Alert
								message="Đăng nhập thất bại"
								description={loginError}
								type="error"
								showIcon
								closable
								style={{ marginBottom: '24px' }}
							/>
						)}

						<Form
							form={form}
							className='login-form'
							name="login"
							layout="vertical"
							initialValues={{ remember: true }}
							onFinish={onFinish}
							autoComplete="off"
						>
							<Form.Item
								label="Email hoặc tên đăng nhập"
								name="email"
								rules={[{ 
									required: true, 
									message: 'Vui lòng nhập email hoặc tên đăng nhập!' 
								}]}
							>
								<Input
									prefix={<UserOutlined />}
									placeholder="Nhập email hoặc tên đăng nhập"
									size="large"
									className="login-input"
								/>
							</Form.Item>

							<Form.Item
								label="Mật khẩu"
								name="password"
								rules={[{ 
									required: true, 
									message: 'Vui lòng nhập mật khẩu!' 
								}]}
							>
								<Input.Password
									prefix={<LockOutlined />}
									placeholder="Nhập mật khẩu"
									size="large"
									className="login-input"
									iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
								/>
							</Form.Item>

							<Form.Item>
								<div className='login-options'>
									<Form.Item name="remember" valuePropName="checked" noStyle>
										<Checkbox>Ghi nhớ đăng nhập</Checkbox>
									</Form.Item>
									<Link 
										className='forgot-password-link'
										onClick={() => navigate('/forgot-password')}
									>
										Quên mật khẩu?
									</Link>
								</div>
							</Form.Item>

							<Form.Item>
								<Button
									type="primary"
									htmlType="submit"
									size="large"
									loading={isLoading}
									className="login-button"
									block
								>
									{isLoading ? 'Đang đăng nhập...' : 'Đăng nhập'}
								</Button>
							</Form.Item>

							<div className='register-link'>
								<Text type="secondary">
									Chưa có tài khoản? {' '}
									<Link 
										strong
										onClick={() => navigate('/register')}
									>
										Đăng ký ngay
									</Link>
								</Text>
							</div>
						</Form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default OutLoginLayout